/**
 * 是否领军人才
 */
 export default Object.freeze({
    YES: '1', // 是
    NO: '0', // 否
})